import { atom } from 'jotai';

import APP_CONFIG from '@/configs/app-config';
import { type ListingCardView } from '@/features/listing/types/listing-types';

// eslint-disable-next-line import/prefer-default-export
export const listingsViewAtom = atom<ListingCardView>(APP_CONFIG.defaultListingCardView);
